// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderHeader_container__3-pE4","highlight":"OrderHeader_highlight__3UOEd"};